import React from 'react';
import { cn } from '../../design-system/cn';
import { statusPill } from '../../design-system/tokens/status';

const VARIANT_MAP = {
  live: statusPill.live,
  upcoming: statusPill.upcoming,
  scheduled: statusPill.scheduled,
  final: statusPill.final,
};

/**
 * StatusPill — compact uppercase status chip for cards and lists.
 */
export default function StatusPill({
  variant = 'scheduled',
  className,
  children,
}) {
  return (
    <span className={cn(statusPill.base, VARIANT_MAP[variant] || statusPill.scheduled, className)}>
      {children}
    </span>
  );
}
